import 'phaser'
import {
    CST
} from '../CST'

export default class Boot extends Phaser.Scene {

    constructor(){
        super(CST.SCENES.BOOT);
    }

    preload(){
        //this.load.image();
    }

    create(){
        this.scene.start(CST.SCENES.PRELOAD);
    }
}